export const routes = [
  {
    path: "/faixas",
    component: () => import("./components/List"),
    name: "faixa.list",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/faixas/edit/:id",
    component: () => import("./components/CriarFaixa"),
    name: "faixa.editar",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/faixas/add",
    component: () => import("./components/CriarFaixa"),
    name: "faixa.add",
    meta: {
      requiresAuth: true,
    },
  },
];
